export default "__VITE_ASSET__56c5e0ed__"